import { createFileRoute, Outlet } from "@tanstack/react-router";
import { ApplicationView } from "./-pages/applicationView";

export const Route = createFileRoute("/_dashboard/$datasetSlug/data/applications")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <>
      <ApplicationView />
      <Outlet />
    </>
  );
}
